<script setup>
import { ref, onMounted, nextTick, watch, computed } from "vue";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useRequestsStore } from "@/stores/storeRequests";
import { useQuestionnairesStore } from "@/stores/storeQuestionnaires";
import { useValidation } from "@/utils/useValidataion";
import Inputmask from "inputmask";

const storeField = useFieldsStore();
const storeRequests = useRequestsStore();
const storeQuestionnaires = useQuestionnairesStore();

const value = ref(null);
const inputRef = ref(null);
const errorText = ref(null)
const errorMessage = ref('');

const heightErrorText = computed(() => {
    if (errorText.value) {
        return errorText.value.offsetHeight;
    }
})

const { validation, isValid, isTouched, textError } = useValidation(value);

const props = defineProps({
	stateKey: {
		type: String,
	},
	placeholder: {
		type: String,
		default: "",
	},
	required: {
		type: Boolean,
	},
});

const applyMask = () => {
	if (inputRef.value) {
		const im = new Inputmask({
			mask: "+7 (\\999) 999-99-99",
			placeholder: "_",
			clearIncomplete: true,
			showMaskOnHover: false,
			oncomplete: () => validation(props.stateKey),
			onincomplete: () => validation(props.stateKey),
		});
		im.mask(inputRef.value);
	}
};

onMounted(() => {
	nextTick(() => {
		applyMask();

        // Добавляем обработчик на изменение значения (в т.ч. автозаполнение)
        inputRef.value.addEventListener("change", () => {
            value.value = inputRef.value.value;
            storeField.updateFields(props.stateKey, "title", value.value);
            validation(props.stateKey);
        });
		
	});
	
});

watch(
	() => storeRequests.userData?.phone_number,
	(newVal) => {
		if (newVal !== value.value) {
			value.value = newVal ?? "";
		}
	},
	{ immediate: true }
);

const handleInput = (event) => {
	value.value = event.target.value;
	storeField.updateFields(props.stateKey, "title", value.value);
	validation(props.stateKey);
};
</script>

<template>
	<label :class="['input']">
		<div class="input__holder">
			<input
				ref="inputRef"
				type="tel"
				:placeholder="placeholder"
				:required="required"
				:class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid')]"
				@input="handleInput"
				@blur="validation(stateKey)"
				
				v-model="value"
			/>
			<span class="input__title"><slot></slot></span>
		</div>

		<Transition mode="out-in">
            <span v-if="!!textError" ref="errorText" class="input__error" :style="{ bottom: `${0}px` }">{{ textError }}</span>
        </Transition>
		<Transition mode="out-in">
            <span v-if="!!storeQuestionnaires.textErrorNumberNotFound" ref="errorText" class="input__error" :style="{ bottom: `${0}px` }">{{ storeQuestionnaires.textErrorNumberNotFound }}</span>
        </Transition>
		<Transition mode="out-in">
            <span v-if="!!errorMessage" ref="errorText" class="input__error" :style="{ bottom: `${0}px` }">{{ errorMessage }}</span>
        </Transition>
	</label>
</template>
<style lang="scss" scoped>

.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}
</style>
